<script>
  import {
    ItemsStore,
    SetupStore,
    GameStateStore,
    PlayerId,
    CraftStore,
    IsTurn,
    DecideStore,
    MerchantClicked,
    CurrentStateName
  } from "../../stores/gameStore";
  import CraftingTableTile from "./CraftingTableTile.svelte";

  $: boards = Object.values($SetupStore?.boardOrder);
  $: merchantClicked = $MerchantClicked;
  $: gamestate = $CurrentStateName;
  $: gameStateStore = $GameStateStore;
  $: playerId = $PlayerId;


  let selectableCards;

  $: {
    if (!$GameStateStore || !$ItemsStore) {
      selectableCards = undefined;
      break $;
    }
    if (gameStateStore?.active_player != playerId) {
      selectableCards = undefined;
      break $;
    }
    if (merchantClicked === true) {
      selectableCards = Object.values($ItemsStore)
        .filter(
          (c) =>
            c.card_location === "CRAFTINGTREE"
        )
        .map((c) => c.id);
      break $;
    }
    if (
      gamestate === "actionCraft" ||
      gamestate === "craftOnce"
    ) {
      selectableCards = $CraftStore;
      break $;
    }
    if (
      gamestate === "decideCraftMaterial" &&
      $DecideStore?.combinedItem
    ) {
      selectableCards = [$DecideStore.combinedItem];
      break $;
    }
    if (gamestate === "actionGuard" ||
        gamestate === "takeItemToUse" ||
        gamestate === "rogueAction1" ||
        gamestate === "rogueAction2" ||
        gamestate === "merchantTakeItem"

    ) {
      selectableCards = Object.values($ItemsStore)
        .filter(
          (c) =>
            c.card_location === "CRAFTINGTREE" &&
            $SetupStore.data.cards[c.id].level == 1
        )
        .map((c) => c.id);
      break $;
    }
    if ($GameStateStore.name === "takeClass2") {
      selectableCards = Object.values($ItemsStore)
        .filter(
          (c) =>
            c.card_location === "CRAFTINGTREE" &&
            $SetupStore.data.cards[c.id].level == 2
        )
        .map((c) => c.id);
      break $;
    }
    if ($GameStateStore.name === "takeClass3") {
      selectableCards = Object.values($ItemsStore)
        .filter(
          (c) =>
            c.card_location === "CRAFTINGTREE" &&
            $SetupStore.data.cards[c.id].level == 3
        )
        .map((c) => c.id);
      break $;
    }
    selectableCards = undefined;
  }


  let action;
  $: {
    if (merchantClicked === true) {
      action = "merchantToken";
      break $;
    }
    if (
      gamestate === "actionCraft" ||
      gamestate === "craftOnce"
    ) {
      action = "craftCombine";
      break $;
    }
    if (
      gamestate === "actionGuard" ||
      gamestate === "takeClass2" ||
      gamestate === "takeClass3" ||
      gamestate === "takeItemToUse" ||
      gamestate === "rogueAction1" ||
      gamestate === "rogueAction2" ||
      gamestate === "merchantTakeItem"
    ) {
      action = "getItem";
      break $;
    }
    action = "";
  }
</script>

<div class="wrapper shadow-md">
  {#each boards as id}
    <CraftingTableTile {id} scale={0.6} {selectableCards} {action} />
  {/each}
</div>

<style>
  .wrapper {
    display: flex;
    border-radius: 10px;
  }
</style>
